// The packet a removed interviewer opens after an approved panel change revoked it (D17, CR-075 "Revoke removed
// interviewer access"): the lock state with the date, never the packet. Only the person whose access was revoked sees
// this: the caller renders it when `panel.my_acknowledgments.revoked` names this packet series for the viewer; anyone
// else asking for the same id gets the ordinary not-found (Law 15).

import { DOCUMENT_LABELS, EmptyState, LABEL_TEMPLATES, PageHeader, formatDate, type Instant } from "@/mc";
import { McScope } from "./McScope";

export function RevokedPacketState({ revokedAt }: { revokedAt: Instant }) {
  return <EmptyState revoked>{LABEL_TEMPLATES.packetRevoked({ date: formatDate(revokedAt) })}</EmptyState>;
}

export function RevokedPacket({ revokedAt }: { revokedAt: Instant }) {
  return (
    <McScope>
      {/* the screen's heading: the route announces it and the capture waits for it, as on every screen */}
      <PageHeader title={DOCUMENT_LABELS.interviewPacket} sm />
      <RevokedPacketState revokedAt={revokedAt} />
    </McScope>
  );
}
